import { render, staticRenderFns } from "./AdminSkinCell.vue?vue&type=template&id=0bd6fb96&scoped=true&"
import script from "./AdminSkinCell.vue?vue&type=script&lang=ts&"
export * from "./AdminSkinCell.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSkinCell.vue?vue&type=style&index=0&id=0bd6fb96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6fb96",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
